
import React from "react";
import { Navigate } from "react-router-dom";
import { useUserSuperEmpresa } from "./AuthContext";

const ProtectedRoute = ({ children }) => {
  const { Token } = useUserSuperEmpresa();
  return Token ? children : <Navigate to="/" replace />;
};

export default ProtectedRoute;
